import React from "react";
import { GLOBAL_NAV_LINKS } from "./Nav";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/[0.06] py-12 bg-[#020B14]"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              src="/katlas-mark.png"
              alt=""
              aria-hidden="true"
              className="h-7 w-auto"
            />
            <span className="font-display tracking-[0.18em] text-sm font-semibold text-white">
              KATLAS
            </span>
            <span className="mono text-[10px] uppercase tracking-[0.2em] text-slate-500 ml-2 border-l border-white/10 pl-2">
              Governance by Design
            </span>
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-2 text-[12px] text-slate-400">
            {GLOBAL_NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="hover:text-white"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-6 text-[12px] text-slate-400">
          <span className="mono text-[10px] uppercase tracking-[0.22em] text-slate-500 mr-2">
            Contact:
          </span>
          <a
            href="mailto:edward.cole@katlastechnology.io"
            data-testid="footer-contact-email"
            className="text-slate-200 hover:text-white underline underline-offset-4 decoration-white/15 hover:decoration-white/60 transition-colors break-all"
          >
            edward.cole@katlastechnology.io
          </a>
        </div>

        <div className="mt-10 pt-6 border-t border-white/[0.04] flex flex-col sm:flex-row gap-3 justify-between text-[11px] mono uppercase tracking-[0.18em] text-slate-600">
          <span>© {new Date().getFullYear()} KATLAS Technology — All rights reserved</span>
          <span>Receipts are the unit of trust.</span>
        </div>
      </div>
    </footer>
  );
};
